<template lang="pug">
    spinner.l-flex-row--center.l-align-center(v-if="isLoading" width="200" height="200")
    div(v-else)
        sectionHeader(title="business apps")
        ul.scrollbar.is-scrollable.business-app-container
            li.business-app-item(v-for="app in sortedList" :key="app.id")
                div.l-flex-row.l-flex-row--between.switch-container-business-app.flex-1
                    switchItem.switch-status.l-flex-box.l-align-center(
                        :label="app.label"
                        :key='app.id'
                        :id="app.id"
                        :title="app.label"
                        type="businessApp"
                        inputName="business-app-status"
                        :fullData="app"
                        @businessAppUpdated="editBusinessAppsStatus"
                        :isSwitchActive="isBusinessAppActive(app.id)"
                        :noFlexBetween="true"
                    )
                p.business-app-description {{app.description}}

</template>
<script>
import SwitchItem from '@/components/common/SwitchItem'
import SectionHeader from '@/components/common/SectionHeader'

import { mapState, mapActions } from 'vuex'
import { isEmpty, toNumber, find, sortBy } from 'lodash'

export default {
    name: 'BusinessAppsSettings',

    components: {
        SwitchItem,
        SectionHeader
    },

    mounted() {
        //retrieve Business app data
        if (isEmpty(this.businessApps.list)) {
            this.isLoading = true
            this.retrieveBusinessApps().then(() => {
                this.isLoading = false
            })
        }
    },

    watch: {},

    data() {
        return {
            isLoading: false
        }
    },

    computed: {
        ...mapState('data/settings', {
            businessApps: state => state.businessApps
        }),
        sortedList() {
            const businessAppsEnabled = this.businessApps.list
                .filter((businessApp) => businessApp.status === 'enabled')
            return sortBy(businessAppsEnabled, 'label')
        }
    },

    methods: {
        ...mapActions('data/settings', [
            'retrieveBusinessApps',
            'retrieveBusinessAppsProductAccount',
            'linkBusinessAppWithAnAccount',
            'unlinkBusinessAppWithAnAccount'
        ]),

        editBusinessAppsStatus(id) {
            this.isBusinessAppActive(id) ? this.unlinkBusinessAppWithAnAccount({ businessAppId: id }) : this.linkBusinessAppWithAnAccount({ businessAppId: id })
        },

        isBusinessAppActive(id) {
            const isActive = find(this.businessApps.productAccountList, item => toNumber(item.id) === toNumber(id))
            return isActive ? true : false
        }
    }
}
</script>
